import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  allowUrls: ["http://localhost:5173", "https://admin.app.kalialab.de/assets", "https://admin.samson.kalialab.de/assets", "https://admin.booking.kalialab.de/assets"],
});
